module.exports = __webpack_public_path__ + "img/ic_play.3faf9cca.svg";